import React, {useEffect, useState} from "react";
import {Button, Row, Col, Modal, Radio, notification} from "antd";
import '../modals.css';
import {deliveriesService, distributionCenterService} from "../../../services";
import Spinner from "../../spinner";
import {ShortDate} from "../../tools/delivery-tools";
import i18n from "i18next";


export default function ModalChooseLoadingGate({
                                                 isShow, id, onCloseModal, setNeedUpdate, date
                                               }) {
  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [loadingTime, setLoadingTime] = useState('');

  useEffect(() => {
    if (isShow && loading) {
      deliveriesService.getAvailableLoadingTime(id)
        .then((response) => {
          setData(response);
          setLoading(false);
        })
        .catch((errMsg) => {
          notification.error({
            message: i18n.t('components.notification.titles.getAvailableLoadingTime'), description: errMsg
          });
          setLoading(false);
        })
    }
  }, [loading, isShow])


  const onSignUp = () => {
    deliveriesService.signUpLoadingTime(id, loadingTime)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.cancelLoadingSignUp.success'), description: response.message,
        });
        onCloseModal();
        setNeedUpdate(true);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.cancelLoadingSignUp.success'), description: err,
        });
        setLoading(true);
      })
  }

  return (<Modal
      title={<>
        <div>{i18n.t('modals.modalChooseLoadingGate.title')}</div>
        <ShortDate date={date}/></>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
        setLoading(true);
      }}
      forceRender={true}
      footer={data.length ? [<Button htmlType="submit" key="submit" type="primary"
                                     style={bigButtonStyle}
                                     onClick={() => onSignUp()}
      >{i18n.t('modals.modalChooseLoadingGate.buttons.signUp')}</Button>,] : [<Button htmlType="button" key="button" type="primary"
                                        style={bigButtonStyle}
                                        onClick={() => {
                                          onCloseModal();
                                          setLoading(true);
                                        }}
      >{i18n.t('main.buttons.close')}</Button>,]}
    >
      <Spinner loading={loading}>
        <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
          <Col span={24}>
            <Radio.Group className="radio-group-primary">
              {(data && data.length) ? data.map((item, index) => {
                return <Radio.Button key={index} value={item}
                                     style={{margin: "5px"}}
                                     onClick={() => setLoadingTime(item)}
                >{item}</Radio.Button>
              }) : null}
              {!data.length ? (<h2><b>{i18n.t('modals.modalChooseLoadingGate.empty')}</b></h2>) : null}
            </Radio.Group>
          </Col>
        </Row>
      </Spinner>
    </Modal>);
}
